<template>
  <v-container fluid v-if="loaded">
    <page-header>
      <v-breadcrumbs>
        <v-breadcrumbs-item to="/secure/courses/management"
          >Course Management</v-breadcrumbs-item
        >
        <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
        <v-breadcrumbs-item
          :to="{ name: 'CourseDetail', params: { id: $route.params.courseId } }"
        >
          {{ course.name }}
        </v-breadcrumbs-item>
        <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
        <v-breadcrumbs-item :disabled="true">
          Substitute Teacher
        </v-breadcrumbs-item>
      </v-breadcrumbs>
    </page-header>

    <v-card v-if="loaded" width="100%" class="mx-auto">
      <v-card-text>
        <div class="mx-4">
          <div class="text-subtitle-2 mb-10">Choose a substitute for {{$route.params.date | formatDateTime}}</div>
<v-form ref="form" lazy-validation>
          <v-select
            v-model="originalTeacher"
            :items="schedule.teachers"
            item-value="id"
            item-text="name"
            label="Original Teacher"
            :rules="[rules.required]"
            return-object
            clearable
          />
          <div v-if="originalTeacher" class="text-body mb-10">
            <span class="text-subtitle-2">About existing teacher</span> 
            <div class="text-body" style="white-space: pre-line;">{{originalTeacher.about ? originalTeacher.about:'N/A'}}</div>
          </div>

          <v-select
            v-model="substituteTeacher"
            :items="teachers"
            item-value="id"
            item-text="name"
            label="Substituting Teacher"
            :rules="[rules.required]"
            return-object
            clearable
          />
          <div v-if="substituteTeacher" class="mb-10">
            <span class="text-subtitle-2">About substitute teacher</span> 
            <div class="text-body" style="white-space: pre-line;">{{substituteTeacher.about ? substituteTeacher.about:'N/A'}}</div>
          </div>
</v-form>
        </div>

      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn :disabled="isAppLoading" class="mb-5" @click="updateSubstituteTeacher"> Substitute Teacher</v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>

  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from 'moment';
import {rules} from '@/store/util/rules.js'

const PageHeader = () => import("@/components/common/PageHeader.vue");

export default {
  data() {
    return {
      id: null,
      originalTeacher: null,
      teachers: [],
      substituteTeacher: null,
      loaded: false,
      schedule: null,
      substituteDate: null,
      course: {},
      rules
    };
  },
  computed: {
    ...mapGetters(["isAppLoading"]),
  },
  components: {
    PageHeader,
    
  },
  filters:{
    formatDateTime(value) {
      return moment(value).format("ddd, MMM DD YYYY h:mm a");
    },
  },
  methods: {
    ...mapActions(["addErrorMessage"]),
    async initCourseSchdule(courseScheduleId) {
      if (!courseScheduleId) {
        return;
      }
      return await this.$axios
        .get("/course-schedule/get-by-id", {
          params: { id: courseScheduleId },
        })
        .then((resp) => {
          return resp.data;
        })
        .catch(() => {
          this.addErrorMessage("Error loading course from server");
        });
    },
    async loadTeachers() {
      const data = {
        pageSize: 1000,
        sortInfos: [{ sortCol: "firstName", sortDir: "asc" }],
        registered: true,
      };

      const result = await this.$axios
        .post("/teacher/search", data)
        .then((resp) => {
          this.teachers = resp.data.data.content.map((t) => {
            return Object.assign({ name: `${t.firstName} ${t.lastName}` }, t);
          });
        })
        .catch(() => {
          this.addErrorMessage("Error loading teachers from server");
        });

      return result;
    },
    updateSubstituteTeacher() {
      if(!this.$refs.form.validate()){
        this.addErrorMessage("Please check your selections")
        return;
      }

      const data = {
        originalTeacherId: this.originalTeacher.id,
        newTeacherId: this.substituteTeacher.id,
        courseScheduleId: this.schedule.id,
        date: moment(this.substituteDate).format("YYYY-MM-DD")
      }

      console.log(data);
      this.$axios.post('/course-schedule/substitute-teacher', data)
        .then( () => {
          this.$router.push({name: 'CourseDetail', params: {id: this.course.id, tab: 'tab-schedule'}})
        })
        .catch( () => {
          this.addErrorMessage('Error substituting teacher');
        })

    },
  },
  mounted() {
    // const courseId = this.$route.params.courseId
    const scheduleId = this.$route.params.scheduleId
    this.substituteDate = this.$route.params.date

    this.initCourseSchdule(scheduleId).then((schedule) => {

      if(schedule){
        this.schedule = schedule;
        this.course = schedule.course;
        schedule.teachers.forEach(t => {
          t.name = `${t.firstName} ${t.lastName}`
        })
  
        this.loadTeachers().then(() => {
          const teacherId = this.$route.params.teacherId
          if(teacherId){
            this.originalTeacher = this.teachers.find(t => t.id == teacherId);
          }
          this.loaded = true;
        });
      }
    });
  },
};
</script>

<style>
</style>